import { proxy } from "valtio";
import { devtools } from "valtio/utils";

import { POSITION_BOTTOM } from "@constants/index";

type StoreDiversType = {
    centralizedPrintingPrintOtherPeople: boolean;
    standAlonePrintingStationPrints: boolean;
    printingOptionsA4Format: boolean;
    printingOptionsPrintingProcess: boolean;
    printingOptionsSpecialCharacters: boolean;
    printingOptionsInstalledPrinter: boolean;
    printingOptionsForcePaper: boolean;
    printingOptionsDeportedServer: boolean;
    // Pending order (Commande en attente)
    pendingBarcodeChecked: boolean;
    pendingBarcodePosition: string;
    pendingQrCodeChecked: boolean;
    pendingQrCodePosition: string;
    // Order (Commande)
    orderBarcodeChecked: boolean;
    orderBarcodePosition: string;
    orderQrCodeChecked: boolean;
    orderQrCodePosition: string;
    paperlessTicket: boolean;
    qrCodeType: "url" | "image";
    qrCodeUrl: string;
    qrCodeImage: string;
};

export const storeDivers = proxy<StoreDiversType>({
    centralizedPrintingPrintOtherPeople: false,
    standAlonePrintingStationPrints: false,
    printingOptionsA4Format: false,
    printingOptionsPrintingProcess: false,
    printingOptionsSpecialCharacters: false,
    printingOptionsInstalledPrinter: false,
    printingOptionsForcePaper: false,
    printingOptionsDeportedServer: false,
    pendingBarcodeChecked: false,
    pendingBarcodePosition: POSITION_BOTTOM,
    pendingQrCodeChecked: false,
    pendingQrCodePosition: POSITION_BOTTOM,
    orderBarcodeChecked: false,
    orderBarcodePosition: POSITION_BOTTOM,
    orderQrCodeChecked: false,
    orderQrCodePosition: POSITION_BOTTOM,
    paperlessTicket: false,
    qrCodeType: "url",
    qrCodeUrl: "",
    qrCodeImage: "",
});

if (
    process.env.REACT_APP_VERIFY === "dev" ||
    process.env.REACT_APP_VERIFY === "recette"
) {
    devtools(storeDivers);
}

export function setCentralizedPrintingPrintOtherPeople(
    centralizedPrintingPrintOtherPeople: boolean
): void {
    storeDivers.centralizedPrintingPrintOtherPeople = centralizedPrintingPrintOtherPeople;
}
export function setStandAlonePrintingStationPrints(
    standAlonePrintingStationPrints: boolean
): void {
    storeDivers.standAlonePrintingStationPrints = standAlonePrintingStationPrints;
}
export function setPaperlessTicket(paperlessTicket: boolean): void {
    storeDivers.paperlessTicket = paperlessTicket;
}
export function setPrintingOptionsA4Format(
    printingOptionsA4Format: boolean
): void {
    storeDivers.printingOptionsA4Format = printingOptionsA4Format;
}
export function setPrintingOptionsPrintingProcess(
    printingOptionsPrintingProcess: boolean
): void {
    storeDivers.printingOptionsPrintingProcess = printingOptionsPrintingProcess;
}
export function setPrintingOptionsSpecialCharacters(
    printingOptionsSpecialCharacters: boolean
): void {
    storeDivers.printingOptionsSpecialCharacters = printingOptionsSpecialCharacters;
}
export function setPrintingOptionsInstalledPrinter(
    printingOptionsInstalledPrinter: boolean
): void {
    storeDivers.printingOptionsInstalledPrinter = printingOptionsInstalledPrinter;
}
export function setPrintingOptionsForcePaper(
    printingOptionsForcePaper: boolean
): void {
    storeDivers.printingOptionsForcePaper = printingOptionsForcePaper;
}
export function setPrintingOptionsDeportedServer(
    printingOptionsDeportedServer: boolean
): void {
    storeDivers.printingOptionsDeportedServer = printingOptionsDeportedServer;
}

// Pending order setters
export function setPendingBarcodeChecked(val: boolean): void {
    storeDivers.pendingBarcodeChecked = val;
}
export function setPendingBarcodePosition(val: string): void {
    storeDivers.pendingBarcodePosition = val;
}
export function setPendingQrCodeChecked(val: boolean): void {
    storeDivers.pendingQrCodeChecked = val;
}
export function setPendingQrCodePosition(val: string): void {
    storeDivers.pendingQrCodePosition = val;
}

// Order setters
export function setOrderBarcodeChecked(val: boolean): void {
    storeDivers.orderBarcodeChecked = val;
}
export function setOrderBarcodePosition(val: string): void {
    storeDivers.orderBarcodePosition = val;
}
export function setOrderQrCodeChecked(val: boolean): void {
    storeDivers.orderQrCodeChecked = val;
}
export function setOrderQrCodePosition(val: string): void {
    storeDivers.orderQrCodePosition = val;
}

export function setQrCodeType(qrCodeType: "url" | "image"): void {
    storeDivers.qrCodeType = qrCodeType;
}

export function setQrCodeUrl(qrCodeUrl: string): void {
    storeDivers.qrCodeUrl = qrCodeUrl;
}

export function setQrCodeImage(qrCodeImage: string): void {
    storeDivers.qrCodeImage = qrCodeImage;
}

export function resetStore() {
    storeDivers.centralizedPrintingPrintOtherPeople = false;
    storeDivers.standAlonePrintingStationPrints = false;
    storeDivers.printingOptionsPrintingProcess = false;
    storeDivers.printingOptionsSpecialCharacters = false;
    storeDivers.printingOptionsInstalledPrinter = false;
    storeDivers.printingOptionsForcePaper = false;
    storeDivers.printingOptionsDeportedServer = false;
    storeDivers.printingOptionsA4Format = false;
    storeDivers.pendingBarcodeChecked = false;
    storeDivers.pendingBarcodePosition = POSITION_BOTTOM;
    storeDivers.pendingQrCodeChecked = false;
    storeDivers.pendingQrCodePosition = POSITION_BOTTOM;
    storeDivers.orderBarcodeChecked = false;
    storeDivers.orderBarcodePosition = POSITION_BOTTOM;
    storeDivers.orderQrCodeChecked = false;
    storeDivers.orderQrCodePosition = POSITION_BOTTOM;
    storeDivers.qrCodeType = "url";
    storeDivers.qrCodeUrl = "";
    storeDivers.qrCodeImage = "";
    storeDivers.paperlessTicket = false;
}

export default storeDivers;
